import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { topNavEvent } from "@faire/retailer-visitor-shared/components/Header/Events";
import { useHeaderStore } from "@faire/retailer-visitor-shared/components/Header/HeaderStoreProvider";
import { getDocumentOrThrow } from "@faire/web--source/common/globals/getDocument";
import { trackRetailerMobileSidebarAccountDropdownClick } from "@faire/web-api--source/events/retailerMobile/click/sidebarAccountDropdown";
import { useCallback, useEffect } from "react";
export var useHeaderState = function() {
    var _useHeaderStore = _sliced_to_array(useHeaderStore([
        "isShowingAccountMenu",
        "isSearchVisible",
        "query",
        "isShowingMobileSearch",
        "isShowingMenu"
    ]), 2), _useHeaderStore_ = _useHeaderStore[0], isSearchVisible = _useHeaderStore_.isSearchVisible, isShowingAccountMenu = _useHeaderStore_.isShowingAccountMenu, isShowingMenu = _useHeaderStore_.isShowingMenu, isShowingMobileSearch = _useHeaderStore_.isShowingMobileSearch, query = _useHeaderStore_.query, setHeaderStore = _useHeaderStore[1];
    var showMenu = useCallback(function() {
        setHeaderStore({
            isShowingMenu: true
        });
        getDocumentOrThrow().body.classList.add("noscroll");
    }, [
        setHeaderStore
    ]);
    var hideMenu = useCallback(function() {
        setHeaderStore({
            isShowingMenu: false
        });
        getDocumentOrThrow().body.classList.remove("noscroll");
    }, [
        setHeaderStore
    ]);
    var toggleAccountMenu = useCallback(function() {
        topNavEvent("account")();
        setHeaderStore({
            isShowingAccountMenu: !isShowingAccountMenu
        });
        trackRetailerMobileSidebarAccountDropdownClick();
    }, [
        isShowingAccountMenu,
        setHeaderStore
    ]);
    var showMobileSearch = useCallback(function() {
        setHeaderStore({
            isShowingMobileSearch: true,
            isSearchVisible: true
        });
    }, [
        setHeaderStore
    ]);
    var hideMobileSearch = useCallback(function() {
        setHeaderStore({
            isShowingMobileSearch: false
        });
    }, [
        setHeaderStore
    ]);
    var clearSearchQuery = useCallback(function() {
        setHeaderStore({
            query: ""
        });
    }, [
        setHeaderStore
    ]);
    var showSearchQuery = useCallback(function() {
        setHeaderStore({
            isSearchVisible: true
        });
    }, [
        setHeaderStore
    ]);
    var hideSearchQuery = useCallback(function() {
        setHeaderStore({
            isSearchVisible: false
        });
    }, [
        setHeaderStore
    ]);
    var setSearchQuery = useCallback(function(query) {
        setHeaderStore({
            query: query
        });
    }, [
        setHeaderStore
    ]);
    useEffect(function() {
        if (!isSearchVisible) {
            hideMobileSearch();
        }
    }, [
        hideMobileSearch,
        isSearchVisible
    ]);
    return {
        isShowingMenu: isShowingMenu,
        isShowingMobileSearch: isShowingMobileSearch,
        isShowingAccountMenu: isShowingAccountMenu,
        isSearchVisible: isSearchVisible,
        query: query,
        showMenu: showMenu,
        hideMenu: hideMenu,
        toggleAccountMenu: toggleAccountMenu,
        showMobileSearch: showMobileSearch,
        hideMobileSearch: hideMobileSearch,
        clearSearchQuery: clearSearchQuery,
        setSearchQuery: setSearchQuery,
        showSearchQuery: showSearchQuery,
        hideSearchQuery: hideSearchQuery
    };
};
